import React, { Fragment } from 'react'
import { FormInput, FormSubmit, FormWrapper } from '@myxplor/forms'
import withRemoteRequest from '../../remote-request'
import { withRouter } from 'react-router-dom'

const apiEndPoint = (serviceId) => `${process.env.REACT_APP_API_HOST}/api/services/${serviceId}/offboard`

const defaultOnSubmit = ({ remote_request, updateServiceId }) => payload => {
  remote_request.submit(apiEndPoint(payload.service_id), { method: 'GET', jsonAPI: true })
  updateServiceId(payload.service_id)
}

export const GetOffboardingStatus = ({
  formOptions = {},
  remote_request,
  onSubmit = defaultOnSubmit,
  updateServiceId, 
  updateOffboardingStatus
}) => {
  const { loading, success, data, errors } = remote_request.state

  if (success) {
    // Set upstream state to response data
    updateOffboardingStatus(data)
  }

  return (
    <Fragment>
      <FormWrapper
        {...formOptions}
        onSubmit={onSubmit({ remote_request, updateServiceId})}
        render={ formProps => (
          <fieldset>
            <FormInput
              label='Input Service ID'
              name='service_id'
              value={formProps.values.service_id}
              required
              onChange={formProps.onChange}
              errors={Object.keys(errors).length !== 0 ? errors : null}
              loading={loading}
              autofocus
            />
            <FormSubmit 
              loading={loading}
              disabled={!formProps.valid}
              loadingTitle='Finding Offboarding Status...'
            > 
              Find offboarding status
            </FormSubmit>
          </fieldset>    
        )}
      />
    </Fragment>
  )
}

export default withRouter(withRemoteRequest(GetOffboardingStatus))


// WEBPACK FOOTER //
// ./src/offboarding/forms/getOffboardingStatus.js